"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var PhoneVerificationInDepositBonus = function () {
    var _a, _b, _c, _d, _e, _f;
    var tPhone = (0, next_intl_1.useTranslations)('phoneVerification');
    var data = (0, swr_hooks_1.useBonusesForPhoneVerification)().data;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.bonusContainer },
        react_1.default.createElement("div", { dangerouslySetInnerHTML: {
                __html: ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.bonuses) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.descriptions) === null || _c === void 0 ? void 0 : _c.shortTitle)
                    ? tPhone('dontMissChanceVerifyPhoneAndGetBonus', {
                        bonus: "<strong class=\"".concat(styles_module_scss_1.default.bonus, "\">").concat((_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.bonuses) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.descriptions) === null || _f === void 0 ? void 0 : _f.shortTitle, "</strong>"),
                    })
                    : tPhone('verifyPhoneAndSaveNextForDeposits'),
            } })));
};
exports.default = PhoneVerificationInDepositBonus;
